import { styled } from "@mui/material";
const Gradient = styled("div", {
  slot: "Root",
  skipSx: true,
  name: "TruncateGradient"
})`
  background: linear-gradient(
    90deg,
    #ffffff00 0%,
    var(--show-more-color, #fff) 88%,
    var(--show-more-color, #fff) 100%
  );
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
  width: var(--gradient-width, 0px);
`;
export {
  Gradient
};
//# sourceMappingURL=Gradient.js.map
